$(document).ready(function () {
  var $scpi = $('.select2-scpi');
  var $year = $('.select2-scpi-year');

  var yearSelectConfig = {
    width: '100%',
    minimumResultsForSearch: Infinity,
    allowClear: true,
    placeholder: '',
    dropdownParent: $("#year-dropdown-container"),
    language: {
      noResults: function () {
        return "Sélectionner une SCPI";
      }
    },
  }

  $year.select2(yearSelectConfig);

  $scpi.select2({
    width: '100%',
    minimumResultsForSearch: 1,
    allowClear: true,
    placeholder: 'Choisir un fond',
    dropdownParent: $("#scpi-dropdown-container")
  });
  $scpi.one('select2:open', function(e) {
    $('input.select2-search__field').prop('placeholder', 'Saisir le nom d\'une SCPI');
  });

  if ($scpi.length > 0 && $scpi.val() !== "") {
    $.ajax({
      url: '/simulateur/list_years',
      type: 'GET',
      dataType: 'json',
      data: {
        fund_id: $scpi.val()
      },
      success: function(data){
        data = data.map(function(v) {
          return v + 1
        })
        $year.empty().trigger("change")
        yearSelectConfig.data = data
        $year.select2(yearSelectConfig).trigger("change")
        var prevValue = $year.attr("data-value")
        if (prevValue) {
          $year.val(prevValue)
          $year.change()
        }
      }
    });
  }

  $scpi.change(function() {
    $.ajax({
      url: '/simulateur/list_years',
      type: 'GET',
      dataType: 'json',
      data: {
        fund_id: $scpi.val()
      },
      success: function(data){
        data = data.map(function(v) {
          return v + 1
        })
        $year.empty().trigger("change")
        yearSelectConfig.data = data
        $year.select2(yearSelectConfig).trigger("change")
      }
    });
  });

  $('.o-simulatorForm').submit(function() {
    $moneyField.each(function() {
      var oldValue = $(this).val()
      var digitValue = oldValue.replace(/\D/g,'').replace(/^0+/, '')
      $(this).val(digitValue === "0" ? "" : digitValue)
    })
  })

  handleMoneyField()

  handlePercentInput()
})

var handlePercentInput =  function () {
  let isTypingShortcut = false

  $('.js-money-field[data-motto="%"]').on('keyup keydown', (e) => {
    const key = e.key
    const regex = /([0-9]|Shift|CapsLock|Enter|Esc|Escape|Left|ArrowLeft|Right|ArrowRight|Tab|Backspace|Meta|Control)$/

    // Handle shortcuts
    if (key === 'Meta' || key === 'Control') {
      if (e.type === 'keydown') {
        isTypingShortcut = true
      } else if (e.type === 'keyup') {
        isTypingShortcut = false
      }
    }

    if (!key.match(regex) && !isTypingShortcut) {
      e.preventDefault()
    } else if (key !== 'Backspace' && key !== 'ArrowLeft' && key !== 'ArrowRight') {
      const valLength = e.target.value.length
      if (valLength === 2) {
        e.target.value = e.target.value + '.'
      } else if (valLength === 5 && !isTypingShortcut) {
        e.preventDefault()
      }
    }
  })
}

var handleMoneyField = function () {
  var $moneyField = $('.js-money-field')

  $moneyField.each(function() {
    var oldValue = $(this).val()
    var mottoValue = $(this).data('motto')
    if (oldValue === "") return
    var digitValue = oldValue.replace(/\D/g,'').replace(/^0+/, '')
    digitValue = digitValue.length === 0 ? "0" : digitValue
    if (mottoValue == '€') {
      var newValue = digitValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " " + mottoValue;
    } else if (mottoValue == '%') {
      var newValue = digitValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " " + mottoValue;
    } else {
      var newValue = digitValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " €";
    }
    $(this).val(newValue)
  })

  $moneyField.blur(function () {
    var oldValue = $(this).val()
    var mottoValue = $(this).data('motto')
    var digitValue = oldValue.replace(/\D/g,'').replace(/^0+/, '')
    var percentValue = oldValue.replace(/\D/g,'')
    digitValue = digitValue.length === 0 ? "0" : digitValue
    percentValue = oldValue.length === 0 ? "0" : oldValue
    if (mottoValue == '€') {
      var newValue = digitValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " " + mottoValue;
    } else if (mottoValue == '%') {
      var newValue = percentValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " " + mottoValue;
    } else {
      var newValue = digitValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " €";
    }
    $(this).val(newValue)
  })

  $moneyField.focus(function () {
    var oldValue = $(this).val()
    var mottoValue = $(this).data('motto')
    var digitValue = oldValue.replace(/\D/g,'').replace(/^0+/, '')
    if (mottoValue) {
      if (mottoValue == '€') {
        $(this).val(digitValue === "0" ? "" : digitValue)
      } else {
        var digitValue = oldValue.replaceAll("%","").replace(/\s+/g, '');
        $(this).val(digitValue === "0" ? "" : digitValue)
      }
    } else {
      $(this).val(digitValue === "0" ? "" : digitValue)
    }
  })
}